import axios from "axios";
export const httpGet = (url,params)=>{
  return new Promise((resolve, reject) => {
    axios.get(url,{params:{...params}}).then((res)=>{
      resolve(res.data)
    }).catch((error) => {
      reject(error);
    });
  })
}
export const httpPost =(url,data)=>{
  return new Promise((resolve, reject) => {
    axios.post(url,{...data}).then((res)=>{
      resolve(res.data)
    }).catch((error) => {
      reject(error);
    });
  })
}
